import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { authAxiosInstance, axiosInstance } from "../../../utils/axiosConfig";
import { generateReset, generateSetEditId } from "../../generators/generateReducers";
import { generateStateSingle } from "../../generators/generateState";
import {
  createData,
  deleteData,
  editData,
  fetchData,
  fetchEditData,
} from "../../generators/generateThunks";
const SLICE_NAME = "jobWorkPO";

export const fetchSendJobWorksOrders = fetchData.generateThunk(
  SLICE_NAME,
  SLICE_NAME
);
export const editSendJobWorksOrder = editData.generateThunk(SLICE_NAME, SLICE_NAME);
export const fetchSendJobWorksOrder = fetchEditData.generateThunk(
  SLICE_NAME,
  SLICE_NAME
);
export const deleteSendJobWorksOrder = deleteData.generateThunk(
  SLICE_NAME,
  SLICE_NAME
);
export const createSendJobWorksOrder = createData.generateThunk(
  SLICE_NAME,
  SLICE_NAME
);

export const updateSendJobWorksOrder = createAsyncThunk(
  "jobWorkPO",
  async (data, { rejectWithValue }) => {
    try {
      console.log(data)
      const resp = await authAxiosInstance.patch("jobWorkPO", data);
      if(resp.data){
        return resp.data
      }
    } catch (error) {
      if(error.response.data.message) {
        toast.error(error.response.data.message);
        return rejectWithValue({error : error.response.data.message})
      }
      toast.error("Something went wrong");
      return rejectWithValue({error : "Something went wrong"})
    }
  }
);

export const updateStatusPurchaseOrder = createAsyncThunk(
  "productPO",
  async (data, { rejectWithValue }) => {
    try {
      const resp = await authAxiosInstance.patch("productPO/status", data);
      return resp.data;
    } catch (error) {
      if(error.response.data.message) {
        toast.error(error.response.data.message);
        return rejectWithValue({error : error.response.data.message})
      }
      toast.error("Something went wrong");
      return rejectWithValue({error : "Something went wrong"})
    }
  }
);

const JobWorkOrderSlice = createSlice({
  name: SLICE_NAME,
  initialState: generateStateSingle(SLICE_NAME),
  reducers: {
    reset: generateReset(SLICE_NAME),
    setEditId: generateSetEditId(),
  },
  extraReducers: {
    ...fetchData.generateExtraReducers(fetchSendJobWorksOrders, SLICE_NAME),
    ...createData.generateExtraReducers(createSendJobWorksOrder, SLICE_NAME),
    ...deleteData.generateExtraReducers(deleteSendJobWorksOrder, SLICE_NAME),
    ...fetchEditData.generateExtraReducers(fetchSendJobWorksOrder, SLICE_NAME),
    ...editData.generateExtraReducers(editSendJobWorksOrder, SLICE_NAME),

    [updateSendJobWorksOrder.pending]: (state, action) => {
      state.loading = true;
    },
    [updateSendJobWorksOrder.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [updateSendJobWorksOrder.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload.error
    },
    [updateStatusPurchaseOrder.pending]: (state, action) => {
      state.loading = true;
    },
    [updateStatusPurchaseOrder.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [updateStatusPurchaseOrder.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload.error
    },
  },
});

export const getJobWorkPO = (state) => state.jobWorkPO;
export const { setEditId,reset } = JobWorkOrderSlice.actions;
export default JobWorkOrderSlice.reducer;
